import React, { PureComponent } from 'react';
import DomTemplate from '../mainpage/domTemplate';
import _ from 'lodash';
import shortid from 'shortid';
import commonStore from '../store/commonStore.js';
import DrawingTemplate from './drawingTemplate';
import CitiTableTemplate from './citiTableTemplate';
import { Base64 } from 'js-base64';
import { buildAdaAltText, setTargetValue } from '../utils/general/general';

interface IFigureGallerySlideProps {
    figure: any;
    idx: number;
    arrayIndex: number;
    isDetached?: boolean;
}

class FigureGallerySlide extends PureComponent<IFigureGallerySlideProps, any> {
    public static defaultProps = {
        idx: 0,
        arrayIndex: 0
    };
    public slideNode: any = React.createRef();

    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        this.setAttr();
    }

    public getCaptionTitle(figure: any) {
        return <DomTemplate sourceM={figure.caption} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />;
    }

    public getFigureNote(figure: any) {
        return <DomTemplate sourceM={figure.note} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />;
    }

    public getFootNote(figure: any) {
        let footNote = <DomTemplate sourceM={figure.footNote} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />;
        if (commonStore.getState().asyncStateReducer.docHeaderJsonData.metadata.docFileType == 'HTML' && figure.footNote) {
            footNote = <div dangerouslySetInnerHTML={{ __html: Base64.decode(figure.footNote.data) }}></div>;
        }
        return footNote;
    }

    public getCopyright(image: any) {
        let copyRight = null;
        if (image && image.copyRight){
            if (commonStore.getState().asyncStateReducer.docHeaderJsonData.metadata.docFileType == 'HTML' && image.copyRight.data) {
                copyRight = <div className="image-copyright-container" dangerouslySetInnerHTML={{ __html: Base64.decode(image.copyRight.data) }}></div>;
            } else {
                copyRight = <div className="image-copyright-container"><DomTemplate sourceM={image.copyRight} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} /></div>;
            }
        }
        return copyRight;
    }

    public getFigureADAText (figure: any) {
        let source = '';
        let captionitem = '';
        if (figure.note?.data[0]?.data[0]) {
            source = figure.note.data[0].data[0];
        }
        const caption = !_.isUndefined(figure.leftNavCaption) ? figure.leftNavCaption : figure.caption;
        if (caption.data[0]?.data[0]?.text) {
            captionitem = `Figure: ${caption.data[0].data[0].text}`;
        }
        return buildAdaAltText(captionitem, source);
    }

    public renderTables (tables: any) {
        let templateDom: any = null;
        const multiTablesContainer: Array<any> = [];  // multiple tables
        for (let j = 0; j < tables?.length; j++) {
            multiTablesContainer.push(<CitiTableTemplate source={tables[j]}  key={shortid.generate()}  />);
        }
        templateDom = (
            <div className='multi-gallery-slide-tables'>{multiTablesContainer}</div>
        );
        return templateDom;
    }

    public renderTable (table: any) {
        return (<CitiTableTemplate source={table} />);
    }

    public renderText (text: any) {
        return (<DomTemplate sourceM={text} dataStringM={'paragraph'} classNameM={'fave-gallery-text'} key={shortid.generate()} />);
    }

    public renderImage (image: any, ADAText: string, isInfographic: boolean) {
        const copyright = this.getCopyright(image);
        const drawingTemplate = <DrawingTemplate altText={ADAText} source={image} key={shortid.generate()}
                                                isFigure={!isInfographic} isDetached={this.props.isDetached}  />;
        if (copyright){
            return (<div>
                {drawingTemplate}
                {copyright}
            </div>);
        }
        return (drawingTemplate);
    }
    public renderComplexImages (images: any, ADAText: string, isInfographic: boolean) {
        let templateDom: any = null;
        if (images.length == 1) { // single-img
            let figureImagesData = null;
            for (let i = 0; i < images[0].data.length; i++) {    // implement for prod doc: 1026046 9th FG
                if (images[0].data[i].data.length !== 0) {
                    figureImagesData = images[0].data[i].data;
                    break;
                }
            }
            const singleImgDom = [];
            for (let i = 0; i < figureImagesData.length; i++ ) {
                if (!_.isUndefined(figureImagesData[i]) && figureImagesData[i].class === 'drawing') {
                    const copyright = this.getCopyright(images[0]);
                    const imgDiv = <div key={i} className="single-img">
                                       <DrawingTemplate altText={ADAText} isFigure={!isInfographic} source={figureImagesData[i]} key={shortid.generate()} isDetached={this.props.isDetached}   />
                                   </div>;
                    if (copyright){
                        singleImgDom.push(<div>
                            {imgDiv}
                            {copyright}
                        </div>);
                    } else {
                        singleImgDom.push(imgDiv);
                    }
                } else if (!_.isUndefined(figureImagesData[i]) && figureImagesData[i].class === 'run') {
                    const copyright = this.getCopyright(images[0]);
                    const domTemplate = <DomTemplate altText={ADAText} sourceM={figureImagesData[i]} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />;
                    if (copyright){
                        singleImgDom.push(<div>
                            {domTemplate}
                            {copyright}
                        </div>);
                    } else {
                        singleImgDom.push(domTemplate);
                    }
                }
            }
            templateDom = <>{singleImgDom}</>;
        } else if (images.length == 2) { // two-img
            const twoImgsContainer: Array<any> = [];
            for (let j = 0; j < images.length; j++) {
                const imagesData = images[j];
                const copyright = this.getCopyright(imagesData);
                const domTemplate = <DomTemplate altText={ADAText} sourceM={imagesData} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />;
                if (copyright){
                    twoImgsContainer.push(<div>
                        {domTemplate}
                        {copyright}
                    </div>);
                } else {
                    twoImgsContainer.push(domTemplate);
                }
            }
            templateDom = (
                <div className='multi-img two-img'>{twoImgsContainer}</div>
            );
        } else { // multi-img
            // Scenario: One figure table, four rows and three columns, each row is a figure. Will add unit test data to test the case
            const multiImgsContainer: Array<any> = [];
            for (let j = 0; j < images?.length; j++) {
                const multiFigureImagesData = images[j];
                const copyright = this.getCopyright(multiFigureImagesData);
                const domTemplate = <DomTemplate sourceM={multiFigureImagesData}
                                                        dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />;
                if (copyright){
                    multiImgsContainer.push(<div>
                        {domTemplate}
                        {copyright}
                    </div>);
                } else {
                    multiImgsContainer.push(domTemplate);
                }
            }
            templateDom = (
                <div className='multi-img'>{multiImgsContainer}</div>
            );
        }
        return templateDom;
    }

    public isDrawing(image: any){
        return image && !_.isUndefined(image.data) && !_.isUndefined(image.data[0])
        && !_.isUndefined(image.data[0].data)
        && 'drawing' === image.data[0].data.class;
    }
    public renderNewWordImages (images: any, ADAText: string, isInfographic: boolean) {
        let templateDom: any = null;
        const multiImgsContainer: Array<any> = [];
        const imgLength = images?.length;
        let clsName = "multi-img";
        if (imgLength === 1){
            clsName = "single-img";
        } else if (imgLength === 2){
            clsName = "multi-img two-img";
        }
        for (let j = 0; j < images?.length; j++) {
            const fgImage = images[j];
            if (_.isUndefined(fgImage)){
                continue;
            }
            const cellClass = imgLength > 0 && fgImage.format?.class ? fgImage.format.class : '';
            if (fgImage.class === 'table') {
                const copyright = this.getCopyright(fgImage);
                const citiTableTemplate = <CitiTableTemplate source={fgImage} key={shortid.generate()}/>;
                if (copyright){
                    multiImgsContainer.push(<div>
                    {citiTableTemplate}
                    {copyright}
                    </div>);
                } else {
                    multiImgsContainer.push(citiTableTemplate);
                }
            } else if (this.isDrawing(fgImage) ) {
                multiImgsContainer.push(this.renderImage(fgImage, ADAText, isInfographic));
            } else{
                const copyright = this.getCopyright(fgImage);
                const domTemplate = <DomTemplate sourceM={fgImage}
                                              dataStringM={'paragraph'} classNameM={cellClass} key={shortid.generate()} />;
                if (copyright){
                    multiImgsContainer.push(<div>
                    {domTemplate}
                    {copyright}
                    </div>);
                } else {
                    multiImgsContainer.push(domTemplate);
                }
            }
        }
        templateDom = (
            <div className={ clsName }>{multiImgsContainer}</div>
        );

        return templateDom;
    }

    public renderOtherImages(images: any, ADAText: string, isInfographic: boolean) {
        const multiImgsContainer: Array<any> = [];
        let templateDom: any = null;
        for (let j = 0; j < images?.length; j++) {
            const multiFigureImagesData = images[j];
            if (!_.isUndefined(multiFigureImagesData) && multiFigureImagesData.class === 'drawing') {
                const copyright = this.getCopyright(multiFigureImagesData);
                const drawingTemplate = <DrawingTemplate altText={ADAText} isFigure={!isInfographic} source={multiFigureImagesData} key={shortid.generate()} isDetached={this.props.isDetached}   />;
                if (copyright){
                    multiImgsContainer.push(<div>
                    {drawingTemplate}
                    {copyright}
                    </div>);
                } else {
                    multiImgsContainer.push(drawingTemplate);
                }
            }
        }
        templateDom = (
            <div className='multi-img'>{multiImgsContainer}</div>
        );
        return templateDom;
    }

    public renderDom() {
        const {figure, idx, arrayIndex} = this.props;
        // right pane
        let templateDom: any = null;
        const isInfographic = !!figure.isInfographic || false;
        const ADAText = this.getFigureADAText(figure);
        const isNewWord = !_.isUndefined(figure.isNewWord) ? figure.isNewWord : false;
        if (isNewWord){
            templateDom = this.renderNewWordImages(figure.images, ADAText, isInfographic);
        } else if (!!figure.tables && !_.isEmpty(figure.tables) && figure.tables.length > 1 ) {
            templateDom = this.renderTables(figure.tables);
        } else if (!_.isUndefined(figure.table)) {
            templateDom = this.renderTable(figure.table);
        } else if (_.isUndefined(figure.table) && _.isUndefined(figure.images) && !_.isUndefined(figure.text)) {
            templateDom = this.renderText(figure.text);
        } else if (figure.images && _.isUndefined(figure.images[0].data) && figure.images[0].class === 'drawing' && figure.images.length == 1) {
            // Tested multiple docs' figure gallery, no any one image can enter this if block.
            // Seems this isn't a valid case. But for stable, keep this if block.
            templateDom = this.renderImage(figure.images[0], ADAText, isInfographic);
        } else if (figure.images && !_.isUndefined(figure.images[0].data) && !_.isUndefined(figure.images[0].data[0].data)) {
            templateDom = this.renderComplexImages(figure.images, ADAText, isInfographic);
        } else {
            templateDom = this.renderOtherImages(figure.images, ADAText, isInfographic);
        }
        const domTemplate =
            <div className='figure-gallery-container'>
                {templateDom}
            </div>;

        return (<div data-name={figure.scrollTo} data-fg-array-index={arrayIndex} className={`fg_json_${idx}`} ref={this.slideNode}>
                    <span tabIndex={0} className={`gallary-title ${figure.isInfographic ? 'infographic-img' : ''}`} style={{ display: 'block' }}>{this.getCaptionTitle(figure)}</span>
                    <span className="img-div"> {domTemplate} </span>
                    <div className="gallery-footnote">{this.getFootNote(figure)}</div>
                    <div className="gallery-note">{this.getFigureNote(figure)}</div>
                </div>);
    }

    public render() {
        return <>{this.renderDom()}</>;
    }

    private setAttr() {
        if (this.slideNode.current?.querySelectorAll('a')?.length) {
            this.slideNode.current.querySelectorAll('a').forEach((el: HTMLElement) => {
                const hrefStr = el.getAttribute('href') || '';
                el.setAttribute('target', setTargetValue(hrefStr));
            });
        }
    }
}

export default FigureGallerySlide;
